"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsBase = require("@telus-uds/components-base");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _WebVideo = _interopRequireDefault(require("../WebVideo/WebVideo"));
var _videoPropType = require("./videoPropType");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VideoPickerPlayer = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    video = {},
    videoPlayerRef,
    onStartVideo = () => {}
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackView, {
    space: 3,
    tokens: {
      flexShrink: 1
    },
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: videoPlayerRef,
      children: video.videoId && /*#__PURE__*/(0, _jsxRuntime.jsx)(_WebVideo.default, {
        ...video,
        onStart: () => onStartVideo(video)
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackView, {
      space: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        variant: {
          size: 'h3'
        },
        children: video.title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        variant: {
          colour: 'default'
        },
        children: video.description
      })]
    })]
  });
});
VideoPickerPlayer.displayName = 'VideoPickerPlayer';
VideoPickerPlayer.propTypes = {
  video: _videoPropType.VideoPropType,
  videoPlayerRef: _videoPropType.RefPropType,
  onStartVideo: _propTypes.default.func
};
var _default = exports.default = VideoPickerPlayer;